import styled from 'styled-components';

export const Container = styled.div`
  height: 6.375rem;
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  background-color: #f2f2f2;
  border-bottom: 1px solid #1b7bdd;

  @media (max-width: 991.98px) {
    position: relative;
    padding: 0;
  }

  @media (max-width: 767.98px) {
    margin: 0;
  }

  @media (min-width: 62rem) {
    display: none;
  }
`;

export const Title = styled.span`
  text-align: center;
  font-size: 0.75rem;
  text-transform: uppercase;
  margin: 0 0.5rem;
  font-family: ${({ dir }) => (dir === 'rtl' ? 'GESSTwoDWTCLight,sans-serif ' : 'DINRegular ')};
`;

export const Arrow = styled.div`
  height: auto;
  width: auto;

  .arrow {
    max-width: 1rem;
    margin: 0 0.5rem;
    animation-name: ${({ clicked }) => (clicked ? 'rotate' : 'rotate-back')};
    animation-duration: 400ms;
    animation-timing-function: linear;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
    height: 1rem;
    width: fit-content;
  }

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(180deg);
    }
  }

  @keyframes rotate-back {
    0% {
      transform: rotate(-180deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
`;

export const Button = styled.button`
  padding: 1rem;
  cursor: pointer;
  outline: none;
  border: none;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  background: transparent;
`;
